import React from 'react';

const kvBtnBase={display:'inline-flex',alignItems:'center',justifyContent:'center',gap:'var(--space-3)',fontFamily:'var(--font-text)',fontWeight:'var(--fw-medium)',letterSpacing:'0',border:'1px solid transparent',borderRadius:'var(--radius-control)',cursor:'pointer',transition:'var(--transition-control)',whiteSpace:'nowrap',textDecoration:'none'};
const kvBtnSizes={sm:{height:'var(--control-h-sm)',padding:'0 var(--space-4)',fontSize:'var(--fs-xs)'},md:{height:'var(--control-h-md)',padding:'0 var(--space-6)',fontSize:'var(--fs-sm)'},lg:{height:'var(--control-h-lg)',padding:'0 var(--space-7)',fontSize:'var(--fs-base)'}};
const kvBtnVariants={
  primary:{background:'var(--surface-brand)',color:'var(--text-on-brand)',borderColor:'var(--surface-brand)'},
  secondary:{background:'var(--white)',color:'var(--text-strong)',borderColor:'var(--border-default)'},
  ghost:{background:'transparent',color:'var(--text-brand)',borderColor:'transparent'},
  soft:{background:'var(--surface-brand-soft)',color:'var(--burgundy-800)',borderColor:'transparent'},
  inverse:{background:'var(--white)',color:'var(--ink-950)',borderColor:'var(--white)'},
  danger:{background:'var(--red-600)',color:'var(--white)',borderColor:'var(--red-600)'}
};
const kvBtnHover={
  primary:{background:'var(--surface-brand-hover)',borderColor:'var(--surface-brand-hover)'},
  secondary:{borderColor:'var(--border-strong)',background:'var(--ink-50)'},
  ghost:{background:'var(--surface-brand-soft)'},
  soft:{background:'var(--rose-200)'},
  inverse:{background:'var(--rose-100)',borderColor:'var(--rose-100)'},
  danger:{background:'#a82a22',borderColor:'#a82a22'}
};

export function Button({variant='primary',size='md',block=false,disabled=false,loading=false,iconLeft=null,iconRight=null,as='button',href,onClick,style,children,...rest}){
  const [hover,setHover]=React.useState(false);
  const [press,setPress]=React.useState(false);
  const Tag=as==='a'?'a':'button';
  const off=disabled||loading;
  const s={...kvBtnBase,...kvBtnSizes[size],...kvBtnVariants[variant],
    ...(hover&&!off?kvBtnHover[variant]:null),
    width:block?'100%':'auto',
    transform:press&&!off?'var(--press-scale)':'none',
    opacity:off?0.45:1,cursor:off?'not-allowed':'pointer',...style};
  return React.createElement(Tag,{href:Tag==='a'?href:undefined,disabled:Tag==='button'?off:undefined,onClick:off?undefined:onClick,style:s,
    onMouseEnter:()=>setHover(true),onMouseLeave:()=>{setHover(false);setPress(false);},onMouseDown:()=>setPress(true),onMouseUp:()=>setPress(false),...rest},
    loading?React.createElement('span',{style:{width:14,height:14,border:'2px solid currentColor',borderTopColor:'transparent',borderRadius:'999px',animation:'kv-spin .7s linear infinite'}}):iconLeft,
    children,iconRight);
}
